/**
 * PM Community-Umfrage
 *
 * Das Formular selbst braucht kein JavaScript: Die Radios heissen
 * contact[tags], das Absenden erledigt Shopify. Dieses Skript macht nur
 * den Umgang angenehmer.
 *
 *  - merkt sich die getroffene Wahl lokal, damit die Dankeszeile sie
 *    benennen kann (nach dem Absenden laedt Shopify die Seite neu und
 *    weiss serverseitig nicht mehr, was angeklickt war)
 *  - erkennt Wiederkehrer und waehlt ihre alte Stimme vor
 *  - springt nach dem Absenden zur Bestaetigung statt an den Seitenanfang
 *
 * Ohne JavaScript funktioniert die Umfrage vollstaendig, nur ohne diese
 * drei Annehmlichkeiten. Der Hinweis oben auf der Seite bleibt ohne JS
 * ein gewoehnlicher Ankerlink.
 */

const PM_POLL_SPEICHER = 'pm-poll-votes';

function pmPollLies() {
  try {
    return localStorage.getItem(PM_POLL_SPEICHER);
  } catch (error) {
    // localStorage kann geblockt sein (privater Modus, strenge Einstellungen).
    return null;
  }
}

function pmPollSchreib(wert) {
  try {
    localStorage.setItem(PM_POLL_SPEICHER, wert);
  } catch (error) {
    /* Nicht schlimm: dann fehlt nur die Erinnerung. */
  }
}

function pmPollSanft() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

class PmPoll extends HTMLElement {
  connectedCallback() {
    this.done = this.querySelector('[data-poll="done"]');

    if (this.done) {
      this.zeigeDank();
      return;
    }

    this.addEventListener('change', (event) => {
      const ziel = event.target;
      if (!(ziel instanceof HTMLInputElement) || ziel.dataset.poll !== 'option') return;
      pmPollSchreib(ziel.dataset.label || ziel.value);
    });

    this.stelleWahlWiederHer();
  }

  stelleWahlWiederHer() {
    const gemerkt = pmPollLies();
    if (!gemerkt) return;

    const treffer = [...this.querySelectorAll('[data-poll="option"]')].find(
      (input) => input.dataset.label === gemerkt
    );
    if (treffer) treffer.checked = true;
  }

  /**
   * Waehlt eine Option ueber ihren handleize-Schluessel aus. Wird vom
   * Hinweis oben auf der Seite aufgerufen.
   * @param {string} key
   */
  waehle(key) {
    const treffer = [...this.querySelectorAll('[data-poll="option"]')].find(
      (input) => input.dataset.key === key
    );
    if (!treffer) return false;

    treffer.checked = true;
    treffer.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  zeigeDank() {
    const gemerkt = pmPollLies();
    const zeile = this.querySelector('[data-poll="choice"]');

    if (zeile && gemerkt) {
      zeile.textContent = 'Deine Stimme: ' + gemerkt;
      zeile.hidden = false;
    }

    // Shopify laedt nach dem Absenden die ganze Seite neu und landet oben.
    // Ohne diesen Sprung sieht niemand die Bestaetigung.
    requestAnimationFrame(() => {
      this.done.scrollIntoView({ block: 'center', behavior: pmPollSanft() });
      this.done.focus({ preventScroll: true });
    });
  }
}

class PmPollTeaser extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-teaser-key]');
      if (!chip) return;

      const ziel = document.getElementById(this.dataset.target || 'umfrage');
      const poll = ziel ? ziel.querySelector('pm-poll') : null;
      if (!poll || typeof poll.waehle !== 'function') return;

      // Kein preventDefault: Den Sprung erledigt der Anker selbst. Horizon
      // setzt scroll-behavior:smooth auf html, er ist also ohnehin sanft -
      // und er funktioniert auch dann, wenn dieses Skript nie laedt.
      poll.waehle(chip.dataset.teaserKey);
    });
  }
}

if (!customElements.get('pm-poll')) {
  customElements.define('pm-poll', PmPoll);
}

if (!customElements.get('pm-poll-teaser')) {
  customElements.define('pm-poll-teaser', PmPollTeaser);
}
